import { GuestPreferenceStatModel } from 'api-hooks/guest';
import {
  PreferenceGroupSubTypeEnum,
  getPreferenceGroupsKey,
  useGetPreferenceGroups,
} from 'api-hooks/preference-tag';
import { NavigationRoutes } from 'common/constants';
import { PreferenceGroupTypeEnum } from 'common/constants/enum';
import { ColumnDataType } from 'components/elements/table/type';

import useGetCrudPermission from './use-get-crud-permission';
import useNavigation from './use-navigation';

export function multiplePreferenceTransformer(item: GuestPreferenceStatModel) {
  return {
    id: item.id,
    label: `${item.name} ${item.count > 1 ? `(X${item.count})` : ''}`,
  };
}

export default function useGetMultiplePreferenceColumn({
  type = PreferenceGroupTypeEnum.Booking,
  subType,
}: {
  type?: PreferenceGroupTypeEnum;
  subType: PreferenceGroupSubTypeEnum;
}) {
  const permission = useGetCrudPermission('preference-groups');
  const { navigate } = useNavigation();
  return {
    dataType: ColumnDataType.selectMulti,
    useListQueryHook: useGetPreferenceGroups,
    listKeyFunction: getPreferenceGroupsKey,
    getMemoizedListVariables: (page, q) => ({
      params: {
        q,
        page,
        type,
        sub_type: subType,
      },
    }),
    listTransformer(result) {
      return result.data.map((v) => multiplePreferenceTransformer(v));
    },
    paginationTransformer(result) {
      return result.meta;
    },
    renderCreate: permission.create,
    onClickCreate: () => {
      navigate(NavigationRoutes.PreferenceTagsCreate);
    },
  };
}
